<template>
  <div class="card-infor-wrapper d-flex justify-content-spacebetween">
    <SGPInfoCardComponent>
      <span class="grey--text font-size-14 mr-2 w-500">Serviço:</span>
      <span class="primary--text font-size-18 text-capitalize">
        <strong>{{ circuito?.star21_servico?.servico || '-' }}</strong>
      </span>
    </SGPInfoCardComponent>

    <SGPInfoCardComponent>
      <span class="grey--text font-size-14 mr-2 w-500">Ação:</span>
      <span class="primary--text font-size-18 text-capitalize">
        <strong>{{ dadosFichaTecnica?.workflow?.ctrl_workflow?.workflow || '-' }}</strong>
      </span>
    </SGPInfoCardComponent>

    <SGPInfoCardComponent>
      <span class="grey--text font-size-14 mr-2 w-500">Status:</span>
      <span class="primary--text font-size-18 text-capitalize">
        <strong v-if="!dadosFichaTecnica?.finalized_at">
          {{ dadosFichaTecnica.status?.ctrl_status?.status || '-' }}
        </strong>
        <strong v-else>Concluída</strong>
      </span>
    </SGPInfoCardComponent>

    <SGPInfoCardComponent>
      <span class="grey--text font-size-14 mr-2 w-500">Designação:</span>
      <span class="primary--text font-size-18 text-capitalize">
        <strong>{{ circuito?.designacao?.designacao || '-' }}</strong>
      </span>
    </SGPInfoCardComponent>
  </div>
</template>

<script>
export default {
  name: 'FichaTecnicaInfoCards',
  
  props: {
    dadosFichaTecnica: {
      type: Object,
      required: true
    },
    circuito: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.card-infor-wrapper {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.text-capitalize {
  text-transform: capitalize;
}
</style>
